import { createListenerMiddleware } from '@reduxjs/toolkit';
import { dischargePatientCompleted } from '../reducers/patient';
import { changeAppointmentStatusOnDischarge } from '../reducers/appointments';

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
    actionCreator: dischargePatientCompleted,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        if (action?.payload?.piw) {
            await listenerApi.dispatch(changeAppointmentStatusOnDischarge(action?.payload?.piw));
        }
    },
});

export default listenerMiddleware.middleware;